import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  CircularProgress, 
  Alert, 
  ToggleButton, 
  ToggleButtonGroup,
  Paper
} from '@mui/material';
import { 
  AccountTree as TreeIcon, 
  TableChart as TableIcon,
  ViewList as ListIcon,
  Dashboard as DashboardIcon
} from '@mui/icons-material';
import { inventoryHierarchyService } from '../../services/inventoryHierarchy.service';
import InventoryHierarchyTree from './InventoryHierarchyTree';
import InventoryHierarchyGrid from './InventoryHierarchyGrid';

const InventoryHierarchyPage = () => {
  const [hierarchy, setHierarchy] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewMode, setViewMode] = useState('tree'); // 'tree' or 'grid'

  useEffect(() => {
    loadHierarchy();
  }, []);

  const loadHierarchy = async () => {
    try {
      setLoading(true);
      const response = await inventoryHierarchyService.getInventoryHierarchy();
      
      // Check if response is an array, if not, try to extract the data
      const hierarchyData = Array.isArray(response) 
        ? response 
        : (response.data || response.hierarchy || []);
      
      setHierarchy(hierarchyData);
      setError(null);
    } catch (err) {
      setError('Failed to load inventory hierarchy');
      console.error('Error loading inventory hierarchy:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewModeChange = (event, newMode) => {
    if (newMode !== null) {
      setViewMode(newMode);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 4 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Typography variant="h4">
          Inventory Hierarchy
        </Typography>
        <ToggleButtonGroup
          value={viewMode}
          exclusive
          onChange={handleViewModeChange}
          aria-label="view mode"
          size="small"
        >
          <ToggleButton value="tree" aria-label="tree view">
            <TreeIcon sx={{ mr: 1 }} />
            Tree View
          </ToggleButton>
          <ToggleButton value="grid" aria-label="grid view">
            <DashboardIcon sx={{ mr: 1 }} />
            Grid View
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>
      
      <Paper sx={{ p: 2 }}>
        {viewMode === 'tree' ? (
          <InventoryHierarchyTree hierarchy={hierarchy} />
        ) : (
          <InventoryHierarchyGrid hierarchy={hierarchy} />
        )}
      </Paper>
    </Box>
  );
};

export default InventoryHierarchyPage; 